import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { useI18n } from "vue-i18n-bridge";
import { Gender } from "@/lib/models/nolaContest";
import type { NolaPfContestExtraFieldItem } from "@/lib/models/nolaPfContest";
import ImageView from "@/components/atoms/ImageView.vue";
import type { ContestEntryWorkFormValue } from "@/components/organisms/event/contestEntryWorkFormTypes";
import type { ContestEntryApplicantFormValue } from "./contestEntryApplicantInfoFormEventHandlers";


export default /*#__PURE__*/_defineComponent({
  __name: 'ContestEntryConfirmForm',
  props: {
    applicantForm: { type: null, required: true },
    workForm: { type: null, required: true },
    categoryLabel: { type: String, required: true },
    extraFieldItems: { type: Array, required: true },
    submitting: { type: Boolean, required: true },
    submitError: { type: String, required: true }
  },
  emits: ["back", "submit"],
  setup(__props: any, { emit }: { emit: ({
  (e: "back"): void;
  (e: "submit"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  applicantForm: ContestEntryApplicantFormValue;
  workForm: ContestEntryWorkFormValue;
  categoryLabel: string;
  extraFieldItems: NolaPfContestExtraFieldItem[];
  submitting: boolean;
  submitError: string;
};





const { t } = useI18n();

function formatBirthDateDisplay(birthDate: string): string {
  const matched = birthDate.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!matched) return birthDate;
  return t("contestEntryForm.step3.birthDateFormat", {
    year: matched[1],
    month: Number(matched[2]),
    day: Number(matched[3]),
  });
}

function formatGenderLabel(gender: number): string {
  if (gender === Gender.male) return t("common.gender.male");
  if (gender === Gender.female) return t("common.gender.female");
  if (gender === Gender.other) return t("common.gender.other");
  return t("common.unselected");
}

const applicantFields = computed(() => {
  const fields: { key: string; label: string; value: string; multiline?: boolean }[] = [
    { key: "name", label: t("contestEntryForm.step1.name.label"), value: props.applicantForm.name },
    { key: "nameKana", label: t("contestEntryForm.step1.nameKana.label"), value: props.applicantForm.nameKana },
    { key: "penname", label: t("contestEntryForm.step1.penname.label"), value: props.applicantForm.penname },
    { key: "email", label: t("contestEntryForm.step1.email.label"), value: props.applicantForm.email },
    { key: "phone", label: t("contestEntryForm.step1.phone.label"), value: props.applicantForm.phone },
    {
      key: "gender",
      label: t("contestEntryForm.step1.gender.label"),
      value: formatGenderLabel(props.applicantForm.gender),
    },
    {
      key: "birthDate",
      label: t("contestEntryForm.step1.birthDate.label"),
      value: formatBirthDateDisplay(props.applicantForm.birthDate),
    },
    {
      key: "historyOfAwards",
      label: t("contestEntryForm.step1.historyOfAwards.label"),
      value: props.applicantForm.historyOfAwards,
      multiline: true,
    },
  ];
  return fields;
});

return { __sfc: true,props, emit, t, formatBirthDateDisplay, formatGenderLabel, applicantFields, ImageView }
}

})